import { render } from "./SuccessfulReferral.vue?vue&type=template&id=6b11ed67"
import script from "./SuccessfulReferral.vue?vue&type=script&lang=js"
export * from "./SuccessfulReferral.vue?vue&type=script&lang=js"

import "./SuccessfulReferral.vue?vue&type=style&index=0&id=6b11ed67&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__